import { isAnyObject } from "@-/com.npmjs.is-what";

export interface RelationalFindConfig {
  where?: unknown;
}

export interface RelationalTableQuery {
  findFirst?: (config?: RelationalFindConfig) => unknown;
  findMany?: (config?: RelationalFindConfig) => unknown;
}

export function getRelationalTableQuery(value: unknown): RelationalTableQuery {
  if (!isAnyObject(value)) {
    return {};
  }
  const findFirst = Reflect.get(value, "findFirst");
  const findMany = Reflect.get(value, "findMany");
  return {
    findFirst: typeof findFirst === "function" ? findFirst.bind(value) : undefined,
    findMany: typeof findMany === "function" ? findMany.bind(value) : undefined,
  };
}
